var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.loggedIn)?_c('div',[_c('render-content',{attrs:{"id":"home"}}),(_vm.loggedIn)?_c('current-appointments'):_vm._e(),(_vm.loggedIn)?_c('current-projects'):_vm._e()],1):_c('about')}
var staticRenderFns = []

export { render, staticRenderFns }